<template>
  <div id="header" :style="headerSty">
    <div class="name" :style="nameBg">
        <img class="icon" :style="iconSty" :src="iconSrc" alt="">
        <span>{{type}} DATA REPORT</span>
        <img class="arrow" src="../assets/image/steam/sanjiao.png" alt="">
    </div>
    <div class="title">
        {{title}}
    </div>
  </div>
</template>

<script>
export default {
   props:{
      title:{
         type:[String],
      },
      iconSrc:{
         type:[String],
      },
      headerSty:{
         type:[Object],
      }
   },
   data(){
      return{
         nameBg:{},
         type:'',
         iconSty:{},
      }
   },
   mounted(){
         if(this.$route.query.type=='steam'){
            this.nameBg={
                background:'#1A515C'
            }
            this.type='STEAM'
        }else if(this.$route.query.type=='psn'){
            this.nameBg={
                background:'#192A52'
            }
            this.type='PSN'
        }else if(this.$route.query.type=='xbox'){
             this.nameBg={
                background:'#195229'
            }
            this.type='XBOX'
        }else if(this.$route.query.type=='epic'){
            this.nameBg={
                background:'#484848',
                width:'9.65rem'
            }
            this.type='EPIC'
            this.iconSty.height='0.65rem'
            this.iconSty.width='0.55rem'
        }
   }
}
</script>

<style>
body,html{
   /* font-size: 20px; */
}
#header{
   /* padding: 20.77% 17.7% 0 10%; */
   margin: 0 auto;
}
#header .name{
   /* padding: 0.45rem 0.85rem 0.5rem 0.7rem; */
   width: 10.4rem;
   height: 1.25rem;
   background: #1A515C;
   margin-bottom: 0.5rem;
   display: flex;
   align-items: center;
}
#header .name .icon{
   width: 0.9rem;
   height: 0.9rem;
   margin-right: 0.35rem;
   margin-left: 0.55rem;
}
#header .name .arrow{
   width: 0.2rem;
   height: 0.4rem;
   margin-left: 0.55rem;
}
#header .name span{
   font-size: 0.75rem;
   font-family: AlibabaPuHuiTiMedium;
   font-weight: 400;
   color: #FFF;
   line-height: 12px;
   /* margin-bottom: 0.2rem; */
}
#header .title{
   font-size: 1.75rem;
   font-family: AlibabaPuHuiTiBold;
   font-weight: 400;
   color: #FFFFFF;
   line-height: 1.75rem;
   /* margin-bottom: 0.9rem; */
}
</style>